import Moon from '../../src/legacy/Moon.tsx';
export default Moon;
